import { render, staticRenderFns } from "./roleSubModuleSelection.vue?vue&type=template&id=4de365c4&scoped=true&"
import script from "./roleSubModuleSelection.vue?vue&type=script&lang=js&"
export * from "./roleSubModuleSelection.vue?vue&type=script&lang=js&"
import style0 from "./roleSubModuleSelection.vue?vue&type=style&index=0&id=4de365c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de365c4",
  null
  
)

export default component.exports